import React from "react";
import { Provider } from "react-redux";
import store from "./store";
import { OfferProvider } from "./hooks/offer";
import Layout from "./layouts/Default";
import Page from "./pages/Parcerias";
import "veloe-ds/lib/main.css";

function App() {
  return (
    <OfferProvider>
      <Provider store={store} name="root-content">
        <Layout>
          <Page />
        </Layout>
      </Provider>
    </OfferProvider>
  );
}

export default App;
